import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';

@Component({
  components: { DsModal },
})
export default class ConnectRssComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Array, required: false }) sourceCacheList!: any;
  showModal = this.open;
  formData = {
    channelName: '',
    url: '',
  } as any;
  isCheckForm = {
    url: '',
  };

  handleAddRssItem() {
    // if (this.isCheckForm ){
    //   return;
    // }
    const data: any = {
      channelId: null,
      channelName: 'RSS',
      channelDescription: this.formData.channelName || '',
      channelImageUri: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/rss.png',
      channelType: 'RSS',
      allowAccess: 'true',
      accounts: [
        {
          accountId: null,
          accountName: '-',
          dataSource: [
            {
              dataSourceTypes: ['URL'],
              value: [this.formData.url],
            },
          ],
          isScrap: true,
        },
      ],
    };
    this.$emit('addItemRss', data);
  }

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    this.formData = {
      channelName: '',
      url: '',
    } as any;
    if (this.sourceCacheList.length > 0) {
      console.log(this.sourceCacheList, 'sourceCacheList');
      const matchedChannel = this.sourceCacheList.find(channel => channel.channelType === 'RSS');

      if (matchedChannel) {
        const dataSources = matchedChannel.accounts[0].dataSource;
        dataSources.forEach(ds => {
          if (ds.dataSourceTypes[0] === 'URL') {
            this.formData.url = ds.value[0];
          }
        });
      }
    }
  }
}
